import { type RefSelectProps, Select } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import {
  type ContractType,
  CONTRACT_TYPE_LABEL,
  CONTRACT_TYPE_SELECTABLE
} from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<ContractType, ContractTypeOption>

type ContractTypeOption = { label: string; value: ContractType }

/**
 * 契約種別を選択するSelect
 */
export const ContractTypeSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    // 個建は #5551 で入口を閉じたため選択肢に出さない（CONTRACT_TYPE_SELECTABLE 参照）
    const options: ContractTypeOption[] = CONTRACT_TYPE_SELECTABLE.map(
      (type) => ({
        label: CONTRACT_TYPE_LABEL[type],
        value: type
      })
    )
    const handleChange = useSelectOnChangeHandler({ mode, onChange })

    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
